import { isDefined } from '@sgme/fp';
import type { ColTypeDef, ValueFormatterParams, ValueParserParams } from 'ag-grid-community';
import { NumberAcceleratorCellEditor } from 'components/shared/Blotter/Grid/CellRenderers/number-accelerator-cell-editor';
import { parseNumberWithAccelerator } from 'components/shared/Blotter/Grid/Hooks/number-accelerator';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';

import { defaultFilterOptions } from './utils';

export function useNumberColumnType<T>(
  precision: number,
  filterOptions: string[] = defaultFilterOptions,
): ColTypeDef<T> {
  const { formatNumber } = useSPIntl();
  return useMemo(
    () => ({
      valueFormatter: ({ value }: ValueFormatterParams) =>
        isDefined(value)
          ? formatNumber(value, {
              maximumFractionDigits: precision,
            })
          : '',
      cellEditor: NumberAcceleratorCellEditor,
      valueParser: ({ newValue }: ValueParserParams) => parseNumberWithAccelerator(newValue),
      filter: 'agNumberColumnFilter',
      filterParams: {
        filterOptions,
      },
      cellClass: 'ag-right-aligned-cell',
    }),
    [filterOptions, formatNumber, precision],
  );
}

export function useServerSideNumberColumnType<T>(precision: number): ColTypeDef<T> {
  const { formatNumber } = useSPIntl();
  return useMemo(
    () => ({
      valueFormatter: ({ value }: ValueFormatterParams) =>
        isDefined(value)
          ? formatNumber(value, {
              maximumFractionDigits: precision,
            })
          : '',
      cellClass: 'ag-right-aligned-cell',
    }),
    [formatNumber, precision],
  );
}
